var map = {
	"./close.svg": "27e5",
	"./discord.svg": "dcf1",
	"./facebook.svg": "ff8c",
	"./instagram.svg": "dcf2",
	"./mixer.svg": "28f2",
	"./steam.svg": "be1f",
	"./test.svg": "e524",
	"./twitch.svg": "7aee",
	"./twitter.svg": "459f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba9c";